import { render, staticRenderFns } from "./SectionUseCase.vue?vue&type=template&id=67560712&scoped=true"
import script from "./SectionUseCase.vue?vue&type=script&lang=ts"
export * from "./SectionUseCase.vue?vue&type=script&lang=ts"
import style0 from "./SectionUseCase.vue?vue&type=style&index=0&id=67560712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67560712",
  null
  
)

export default component.exports